import { render, staticRenderFns } from "./decordDetail.vue?vue&type=template&id=518b8f54&scoped=true&"
import script from "./decordDetail.vue?vue&type=script&lang=js&"
export * from "./decordDetail.vue?vue&type=script&lang=js&"
import style0 from "./decordDetail.vue?vue&type=style&index=0&id=518b8f54&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b8f54",
  null
  
)

export default component.exports